// extracted by mini-css-extract-plugin
export default {"getPaid":"GetPaid_getPaid__S721Y","description":"GetPaid_description__Q-fBJ","buttons":"GetPaid_buttons__p4GY3","button":"GetPaid_button__vMj7E"};